import React from 'react';
import { Spinner, Modal } from 'react-bootstrap';

const Charging = () => (
 <Modal size="sm" show={true} backdrop="static" keyboard={false} centered>
  <Spinner animation="grow" variant="light" className="position-absolute top-50 start-50 translate-middle" />

  <Modal.Title className="position-absolute top-50 start-50 translate-middle text-white">Cargando...</Modal.Title>
 </Modal>
);

export default Charging;
